<cue-modal [modal]="modal" class="notch-fix">
  <cue-modal-header title="{{ translation.finishEvent.finishEvent | transloco }}" />
  <cue-modal-body>
    <div class="modal-body">
      <p class="text-center question">
        {{ translation.finishEvent.question | transloco }}

        <strong> <br />{{ modalData.reservation.subject | subjectPipe }} </strong>
      </p>
    </div>
  </cue-modal-body>
  <cue-modal-footer>
    <cue-button (click)="modal.close(0)" [icon]="cueClose" [smallResponsive]="true">
      {{ translation.deletePopup.close | transloco }}
    </cue-button>
    <cue-button (click)="modal.close(1)" [icon]="cueFinish" [type]="'confirm'" [smallResponsive]="true">
      {{ translation.finishEvent.finish | transloco }}
    </cue-button>
  </cue-modal-footer>
</cue-modal>
